import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { Editor } from '@tiptap/react';
import type { FileTransferRiuType } from '@tyro/api';
import { useTranslation } from '@tyro/i18n';
import { InsertImageIcon } from '@tyro/icons';
import { allowedTypes, useUploadAndInsertImage } from '../../../../hooks';
import { IconButtonWithTooltip } from '../../../icon-button-with-tooltip';

interface InsertImageProps {
  editor: Editor | null;
  riuType: FileTransferRiuType;
  isFullScreen?: boolean;
}

export const InsertImage = ({
  editor,
  riuType,
  isFullScreen,
}: InsertImageProps) => {
  const { t } = useTranslation(['common', 'mail']);
  const { getUploadedImagePath } = useUploadAndInsertImage({ riuType });

  const handleUploadImage = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const path = await getUploadedImagePath(event.target.files?.[0]);
    if (!path) return;

    if (editor) {
      editor
        .chain()
        .setImage({ src: path })
        .setTextSelection(editor.state.doc.content.size)
        .focus()
        .insertContent('<p></p>')
        .run();
    }
    event.target.value = '';
  };

  if (!editor) return null;

  return (
    <Stack justifyContent="center" alignItems="center">
      <IconButtonWithTooltip
        title={t('common:tooltipTitles.insertImage')}
        placement="top"
        component="label"
      >
        <InsertImageIcon />
        <input
          type="file"
          accept={allowedTypes.join(', ')}
          hidden
          onChange={handleUploadImage}
        />
      </IconButtonWithTooltip>
      {isFullScreen && (
        <Typography variant="caption" fontSize="10px">
          {t('mail:image')}
        </Typography>
      )}
    </Stack>
  );
};
